const pad = (value) => String(value).padStart(2, '0');

const toInputDateString = (date) =>
	`${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const getMaxAllowedPastDate = () => {
	const date = new Date();
	date.setDate(date.getDate() - 1);
	return toInputDateString(date);
};

export const isTodayOrFutureInputDate = (dateString) => {
	if (!dateString) return false;
	return dateString >= toInputDateString(new Date());
};
